import { Routes, Route } from "react-router-dom";
import routes from "./routes";
import { MantineProvider } from '@mantine/core'

import '@mantine/core/styles.css'
import '@mantine/carousel/styles.css';

function App() {
  return (
    <>
      <MantineProvider defaultColorScheme="dark">
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={<route.component />} />
          ))}
        </Routes>
      </MantineProvider>
    </>
  );
}

export default App;
